import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { AppLayout } from './components/app-layout'
import { ActivityFeedProvider } from './lib/activity-feed'
import { RequireAuth } from './components/require-auth'
import { SkeletonRows } from './components/skeleton-rows'
import { DashboardPage } from './pages/dashboard'
import { LoginPage } from './pages/login'
import { StrategiesPage } from './pages/strategies'

// the pages off the main path load when first opened, so the first paint carries less code (Nov 4 2026)
const SettingsPage = lazy(() => import('./pages/settings').then((m) => ({ default: m.SettingsPage })))
const PnlPage = lazy(() => import('./pages/pnl').then((m) => ({ default: m.PnlPage })))

function PageSkeleton() {
  return (
    <div className="card">
      <SkeletonRows rows={4} columns={3} />
    </div>
  )
}

function WalletRedirect() {
  const location = useLocation()
  return <Navigate to={{ pathname: '/dashboard', search: location.search }} replace />
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <ActivityFeedProvider>
              <AppLayout />
            </ActivityFeedProvider>
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/strategies" element={<StrategiesPage />} />
        <Route path="/pnl" element={<Suspense fallback={<PageSkeleton />}><PnlPage /></Suspense>} />
        {/* the wallet is the dashboard now; old links keep their ?action= */}
        <Route path="/wallet" element={<WalletRedirect />} />
        <Route path="/settings" element={<Suspense fallback={<PageSkeleton />}><SettingsPage /></Suspense>} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  )
}
